import React, { useState, useEffect } from 'react';
import { Form, FormGroup, Label, Input, Col, Button, Card, CardBody, CardHeader } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Swal from 'sweetalert2';
import DataTable from 'react-data-table-component';
import { api_url } from "../globalFunction/global_string";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';

//掃描模式下拉選單使用方法
import SelectTenableNet from "../BasicComponents/SelectTenableNet";
import SelectTenableUnit from "../BasicComponents/SelectTenableUnit";
import SelectTenableUrl from "../BasicComponents/SelectTenableUrl";
import SelectTenableUser from "../BasicComponents/SelectTenableUser";


function CreateTenableApply() {
    //下拉選單使用變數
    const [selectedNet, setSelectedNet] = useState('');
    const [localNetName, setLocalNetName] = useState('');
    const [selectedUnit, setSelectedUnit] = useState('');
    const [localUnitName, setLocalUnitName] = useState('');
    const [selectedUrl, setSelectedUrl] = useState('');
    const [localUrlName, setLocalUrlName] = useState('');
    const [selectedUser, setSelectedUser] = useState('');
    const [localUserName, setLocalUserName] = useState('');

    // 用於切換模式按鈕狀態
    const [checked, setChecked] = useState(false);

    // 個人同時最多可申請主機數
    const [personalMaxApply, setPersonalMaxApply] = useState(16);
    // 個人目前同時已經申請主機數
    const [personalCurrentApply, setPersonalCurrentApply] = useState(0);
    // 個人目前同時可申請主機數
    const [personalAvailableApply, setPersonalAvailableApply] = useState(8);
    // 目前系統已申請主機數
    const [systemCurrentApply, setSystemCurrentApply] = useState(0);



    //撈資料出來使用變數
    const [tableData, setTableData] = useState([]);



    const loadData = async () => {
        const apiUrl = checked
            ? `${api_url}/api/TEN/GetTenableProxySchedule`
            : `${api_url}/api/TEN/GetTenableSchedule`;

        console.log("API URL:", apiUrl);

        const formData = new FormData();
        formData.append("user_type", localStorage.getItem('login_user_type'));
        formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
        formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));

        // 根據模式決定 user_id
        formData.append("user_id", checked ? selectedUser : localStorage.getItem('login_user_id'));

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Authorization": localStorage.getItem('accessToken'),
                },
                body: formData,
            });

            const data = await response.json();
            console.log("API Response:", data);

            if (data.statusCode === 200 && Array.isArray(data.row)) {
                setTableData(data.row);

                const currentApplyCount = data.row.length;
                setPersonalCurrentApply(currentApplyCount);
                setPersonalAvailableApply(personalMaxApply - currentApplyCount);
            } else {
                console.error("API 回傳無效的格式:", data);
            }
        } catch (error) {
            console.error("API 請求錯誤:", error.message);
        }
    };



    const systemCurrentApplyData = async () => {
        const apiUrl = `${api_url}/api/TEN/GetTenableAllcount`;

        try {
            const response = await fetch(apiUrl, {
                method: "Get",
                headers: {
                    "Authorization": localStorage.getItem('accessToken')
                }
            });

            const data = await response.json();
            if (data.statusCode === 200 && Array.isArray(data.row)) {
                setSystemCurrentApply(data.row);
            } else {
                throw new Error('無效的回應格式');
            }
        } catch (error) {
            console.error('Error fetching data:', error.message);
        }
    };

    useEffect(() => {
        loadData();
    }, [checked, selectedUser]);

    useEffect(() => {
        systemCurrentApplyData();
    }, []);

    //申請掃描使用
    const handleSubmit = async (e) => {
        e.preventDefault();

        const apiUrl = checked ? `${api_url}/api/TEN/PostProxyTenableScheduleReference` : `${api_url}/api/TEN/PostTenableScheduleReference`;
        const submitData = new FormData();
        switch (userType) {
            case "S":
                if (checked) {
                    if (!selectedNet) {
                        Swal.fire({
                            title: '提交失敗',
                            text: '請選擇區網',
                            icon: 'error'
                        });
                        return;
                    }
                    if (!selectedUnit) {
                        Swal.fire({
                            title: '提交失敗',
                            text: '請選擇單位',
                            icon: 'error'
                        });
                        return;
                    }

                    if (!selectedUrl) {
                        Swal.fire({
                            title: '提交失敗',
                            text: '請選擇主機名稱',
                            icon: 'error'
                        });
                        return;
                    }
                    if (!selectedUser) {
                        Swal.fire({
                            title: '提交失敗',
                            text: '請選擇使用者人員',
                            icon: 'error'
                        });
                        return;
                    }
                    submitData.append("data.host_ip", localUrlName);
                    submitData.append("data.local_net_id", selectedNet);
                    submitData.append("data.local_unit_id", selectedUnit);
                    submitData.append("data.host_id", selectedUrl)
                    submitData.append("user_id", selectedUser);
                } else {
                    if (!selectedNet) {
                        Swal.fire({
                            title: '提交失敗',
                            text: '請選擇區網',
                            icon: 'error'
                        });
                        return;
                    }
                    if (!selectedUnit) {
                        Swal.fire({
                            title: '提交失敗',
                            text: '請選擇單位',
                            icon: 'error'
                        });
                        return;
                    }
                    if (!selectedUrl) {
                        Swal.fire({
                            title: '提交失敗',
                            text: '請選擇主機名稱',
                            icon: 'error'
                        });
                        return;
                    }
                    submitData.append("current_user_type", localStorage.getItem('login_user_type'));
                    submitData.append("data.host_ip", localUrlName);
                    submitData.append("data.host_id", selectedUrl)
                    submitData.append("data.local_net_id", localStorage.getItem('login_user_net_id'));
                    submitData.append("data.local_unit_id", localStorage.getItem('login_user_unit_id'));
                }
                break;
            case "M":
                if (checked) {
                    if (!selectedUnit) {
                        Swal.fire({
                            title: '提交失敗',
                            text: '請選擇單位',
                            icon: 'error'
                        });
                        return;
                    }
                    if (!selectedUrl) {
                        Swal.fire({
                            title: '提交失敗',
                            text: '請選擇主機名稱',
                            icon: 'error'
                        });
                        return;
                    }
                    if (!selectedUser) {
                        Swal.fire({
                            title: '提交失敗',
                            text: '請選擇使用者人員',
                            icon: 'error'
                        });
                        return;
                    }
                    submitData.append("data.host_ip", localUrlName);
                    submitData.append("data.local_net_id", localStorage.getItem('login_user_net_id'));
                    submitData.append("data.local_unit_id", selectedUnit);
                    submitData.append("data.host_id", selectedUrl)
                    submitData.append("user_id", selectedUser);
                } else {
                    if (!selectedUnit) {
                        Swal.fire({
                            title: '提交失敗',
                            text: '請選擇單位',
                            icon: 'error'
                        });
                        return;
                    }
                    if (!selectedUrl) {
                        Swal.fire({
                            title: '提交失敗',
                            text: '請選擇主機名稱',
                            icon: 'error'
                        });
                        return;
                    }
                    submitData.append("current_user_type", localStorage.getItem('login_user_type'));
                    submitData.append("data.host_ip", localUrlName);
                    submitData.append("data.host_id", selectedUrl)
                    submitData.append("data.local_net_id", localStorage.getItem('login_user_net_id'));
                    submitData.append("data.local_unit_id", localStorage.getItem('login_user_unit_id'));
                }
                break;
            case "N":
                if (!selectedUrl) {
                    Swal.fire({
                        title: '提交失敗',
                        text: '請選擇主機名稱',
                        icon: 'error'
                    });
                    return;
                }
                submitData.append("current_user_type", localStorage.getItem('login_user_type'));
                submitData.append("data.host_ip", localUrlName);
                submitData.append("data.host_id", selectedUrl)
                submitData.append("data.local_net_id", localStorage.getItem('login_user_net_id'));
                submitData.append("data.local_unit_id", localStorage.getItem('login_user_unit_id'));
                break;

            default:
                break;
        }

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Authorization": localStorage.getItem('accessToken')
                },
                body: submitData
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(`Error ${response.status}: ${errorData.row || response.statusText}`);
            }

            const data = await response.json();
            console.log(data)
            if (data.result.statusCode === 200) {
                Swal.fire({
                    icon: 'success',
                    title: '【申請成功】',
                    text: '恭喜'
                });
                loadData();
            } else {
                Swal.fire({
                    title: '提交失敗',
                    text: data.result.row,
                    icon: 'error'
                });
            }
        } catch (error) {
            console.error('Error submitting data:', error.message);
            Swal.fire({
                title: '提交失敗',
                text: error.message,
                icon: 'error'
            });
        }
    };



    //以下是掃描模式下拉選單使用方法
    const handleNetSelectChange = (data) => {
        const { value, selectedName } = data;
        setSelectedNet(value);
        setLocalNetName(selectedName);
        setSelectedUnit('');
        setLocalUnitName('');
    };
    const handleUnitSelectChange = (data) => {
        const { value, selectedName } = data;
        setSelectedUnit(value);
        setLocalUnitName(selectedName);
    };
    const handleUrlSelectChange = (data) => {
        const { value, selectedName } = data;
        setSelectedUrl(value);
        setLocalUrlName(selectedName);
    };


    //切換模式
    const handleChange = () => {
        // 切換模式
        setChecked(!checked);

        // 清空當前資料
        setTableData([]);
        setPersonalCurrentApply(0);
        setPersonalAvailableApply(personalMaxApply);

        // 載入資料
        loadData();
    };


    //以下是代理掃描模式下拉選單使用方法
    const handleProxyUnitSelectChange = (data) => {
        const { value, selectedName } = data;
        setSelectedUnit(value);
        setLocalUnitName(selectedName);
        setSelectedUser('');
        setLocalUserName('');
    };
    const handleUserSelectChange = (data) => {
        const { value, selectedName } = data;
        setSelectedUser(value);
        setLocalUserName(selectedName);
        setSelectedUrl('');
        setLocalUrlName('');
    };

    //依照user_type的權限來顯示畫面
    const userType = localStorage.getItem('login_user_type');  //權限
    const net_name = localStorage.getItem('login_user_net_name'); //區網名稱
    const unit_name = localStorage.getItem('login_local_unit_name'); //區網名稱


    let FormDataUI = null;

    switch (userType) {
        case "S":
            FormDataUI = checked ?
                (
                    <Form onSubmit={handleSubmit}>
                        <FormGroup row>
                            <Label sm={3} className="text-right">區網名稱</Label>
                            <Col sm={7}>
                                <SelectTenableNet
                                    parentName={'superS'}
                                    id={'excel_net_name'}
                                    name={'excel_net_name'}
                                    requiredAPI={'/api/JRCC/GetLocalNetId'}
                                    handleNetSelectChange={handleNetSelectChange}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="excel_unit_name" sm={3} className="text-right">單位名稱</Label>
                            <Col sm={7}>
                                <SelectTenableUnit
                                    parentName={'superS'}
                                    id={'excel_unit_name'}
                                    name={'excel_unit_name'}
                                    requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                    handleUnitSelectChange={handleProxyUnitSelectChange}
                                    selectnet={selectedNet}
                                    local_net_name={localNetName}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="excel_user_name" sm={3} className="text-right">人員資料</Label>
                            <Col sm={7}>
                                <SelectTenableUser
                                    parentName={'superS'}
                                    id={'excel_user_name'}
                                    name={'excel_user_name'}
                                    requiredAPI={'/api/Async/GetUserdatalist'}
                                    handleUserSelectChange={handleUserSelectChange}
                                    selectnet={selectedNet}
                                    local_net_name={localNetName}
                                    local_unit_name={localUnitName}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="excel_unit_url" sm={3} className="text-right">主機名稱</Label>
                            <Col sm={7}>
                                <SelectTenableUrl
                                    parentName={'superSProxyUrl'}
                                    id={'excel_unit_url'}
                                    name={'excel_unit_url'}
                                    requiredAPI={'/api/Async/GetHostUserUrllist'}
                                    selectnet={selectedNet}
                                    selectedUnit={selectedUnit}
                                    selectedUser={selectedUser}
                                    local_net_name={localNetName}
                                    local_unit_name={localUnitName}
                                    onChange={handleUrlSelectChange}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col sm={{ size: 4, offset: 2 }}>
                                <Button
                                    type="submit"
                                    color="primary"
                                    className="col-md-4 col-lg-3 mx-1 my-2"
                                    disabled={personalAvailableApply === 0}
                                >
                                    申請
                                </Button>
                            </Col>
                        </FormGroup>
                    </Form>
                ) :
                (
                    <Form onSubmit={handleSubmit}>
                        <FormGroup row>
                            <Label sm={3} className="text-right">區網名稱</Label>
                            <Col sm={7}>
                                <SelectTenableNet
                                    parentName={'superS'}
                                    id={'excel_net_name'}
                                    name={'excel_net_name'}
                                    requiredAPI={'/api/JRCC/GetLocalNetId'}
                                    handleNetSelectChange={handleNetSelectChange}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="excel_unit_name" sm={3} className="text-right">單位名稱</Label>
                            <Col sm={7}>
                                <SelectTenableUnit
                                    parentName={'superS'}
                                    id={'excel_unit_name'}
                                    name={'excel_unit_name'}
                                    requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                    handleUnitSelectChange={handleUnitSelectChange}
                                    selectnet={selectedNet}
                                    local_net_name={localNetName}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="excel_unit_url" sm={3} className="text-right">主機名稱</Label>
                            <Col sm={7}>
                                <SelectTenableUrl
                                    parentName={'superS'}
                                    id={'excel_unit_url'}
                                    name={'excel_unit_url'}
                                    requiredAPI={'/api/JRCC/GetTenableHostip'}
                                    selectnet={selectedNet}
                                    selectedUnit={selectedUnit}
                                    local_net_name={localNetName}
                                    local_unit_name={localUnitName}
                                    onChange={handleUrlSelectChange}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col sm={{ size: 4, offset: 2 }}>
                                <Button
                                    type="submit"
                                    color="primary"
                                    className="col-md-4 col-lg-3 mx-1 my-2"
                                    disabled={personalAvailableApply === 0}
                                >
                                    申請
                                </Button>
                            </Col>
                        </FormGroup>
                    </Form>
                );
            break;
        case "M":
            FormDataUI = checked ?
                (
                    <Form onSubmit={handleSubmit}>
                        <FormGroup row className="d-flex align-items-center">
                            <Label sm={3} className="text-right">區網名稱</Label>
                            <Col sm={7} className="d-flex align-items-center">
                                <p className="mb-0">{net_name}</p>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="excel_unit_name" sm={3} className="text-right">單位名稱</Label>
                            <Col sm={7}>
                                <SelectTenableUnit
                                    parentName={'superM'}
                                    id={'excel_unit_name'}
                                    name={'excel_unit_name'}
                                    requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                    handleUnitSelectChange={handleUnitSelectChange}
                                    selectnet={localStorage.getItem('login_user_net_id')}
                                    local_net_name={localStorage.getItem('login_user_net_name')}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="excel_user_name" sm={3} className="text-right">人員資料</Label>
                            <Col sm={7}>
                                <SelectTenableUser
                                    parentName={'superS'}
                                    id={'excel_user_name'}
                                    name={'excel_user_name'}
                                    requiredAPI={'/api/Async/GetUserdatalist'}
                                    handleUserSelectChange={handleUserSelectChange}
                                    selectnet={localStorage.getItem('login_user_net_id')}
                                    local_net_name={localStorage.getItem('login_user_net_name')}
                                    local_unit_name={localUnitName}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="excel_unit_url" sm={3} className="text-right">主機名稱</Label>
                            <Col sm={7}>
                                <SelectTenableUrl
                                    parentName={'superMProxyUrl'}
                                    id={'excel_unit_url'}
                                    name={'excel_unit_url'}
                                    requiredAPI={'/api/Async/GetHostUserUrllist'}
                                    selectnet={localStorage.getItem('login_user_net_id')}
                                    selectedUnit={selectedUnit}
                                    selectedUser={selectedUser}
                                    local_net_name={localStorage.getItem('login_user_net_name')}
                                    local_unit_name={localUnitName}
                                    onChange={handleUrlSelectChange}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col sm={{ size: 4, offset: 2 }}>
                                <Button
                                    type="submit"
                                    color="primary"
                                    className="col-md-4 col-lg-3 mx-1 my-2"
                                    disabled={personalAvailableApply === 0}
                                >
                                    申請
                                </Button>
                            </Col>
                        </FormGroup>
                    </Form>
                ) : (
                    <Form onSubmit={handleSubmit}>
                        <FormGroup row className="d-flex align-items-center">
                            <Label sm={3} className="text-right">區網名稱</Label>
                            <Col sm={7} className="d-flex align-items-center">
                                <p className="mb-0">{net_name}</p>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="excel_unit_name" sm={3} className="text-right">單位名稱</Label>
                            <Col sm={7}>
                                <SelectTenableUnit
                                    parentName={'superM'}
                                    id={'excel_unit_name'}
                                    name={'excel_unit_name'}
                                    requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                    handleUnitSelectChange={handleUnitSelectChange}
                                    selectnet={localStorage.getItem('login_user_net_id')}
                                    local_net_name={localStorage.getItem('login_user_net_name')}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="excel_unit_url" sm={3} className="text-right">主機名稱</Label>
                            <Col sm={7}>
                                <SelectTenableUrl
                                    parentName={'superS'}
                                    id={'excel_unit_url'}
                                    name={'excel_unit_url'}
                                    requiredAPI={'/api/JRCC/GetTenableHostip'}
                                    selectedUnit={selectedUnit}
                                    local_unit_name={localUnitName}
                                    selectnet={localStorage.getItem('login_user_net_id')}
                                    onChange={handleUrlSelectChange}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col sm={{ size: 4, offset: 2 }}>
                                <Button
                                    type="submit"
                                    color="primary"
                                    className="col-md-4 col-lg-3 mx-1 my-2"
                                    disabled={personalAvailableApply === 0}
                                >
                                    申請
                                </Button>
                            </Col>
                        </FormGroup>
                    </Form>
                );
            break;
        case "N":
            FormDataUI = (
                <Form onSubmit={handleSubmit}>
                    <FormGroup row className="d-flex align-items-center">
                        <Label sm={3} className="text-right">區網名稱</Label>
                        <Col sm={7} className="d-flex align-items-center">
                            <p className="mb-0">{net_name}</p>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={3} className="text-right">單位名稱</Label>
                        <Col sm={7} className="d-flex align-items-center">
                            <p className="mb-0">{unit_name}</p>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="excel_unit_url" sm={3} className="text-right">主機名稱</Label>
                        <Col sm={7}>
                            <SelectTenableUrl
                                parentName={'superS'}
                                id={'excel_unit_url'}
                                name={'excel_unit_url'}
                                requiredAPI={'/api/JRCC/GetTenableHostip'}
                                selectedUnit={localStorage.getItem('login_user_unit_id')}
                                local_unit_name={localStorage.getItem('login_local_unit_name')}
                                selectnet={localStorage.getItem('login_user_net_id')}
                                onChange={handleUrlSelectChange}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 4, offset: 2 }}>
                            <Button
                                type="submit"
                                color="primary"
                                className="col-md-4 col-lg-3 mx-1 my-2"
                            >
                                申請
                            </Button>
                        </Col>
                    </FormGroup>
                </Form>
            );
            break;
        default:
            break;
    }


    const formatBuildDate = (date) => {
        return date.replace(/\//g, "").replace(/:/g, "").replace(/ /g, "");
    };
    const columns = [
        {
            name: '流水號',
            selector: row => {
                const newFormat = formatBuildDate(row.build_date);
                return `${newFormat}-${row.local_net_id}-${row.local_unit_id}-${row.serial_no}`;
            }
        },
        { name: '主機名稱', selector: row => row.host_name },
        { name: '掃描狀態', selector: row => row.scan_status_description },
        { name: '建立人員', selector: row => row.build_id },
        { name: '建立時間', selector: row => row.build_date },
    ];



    return (
        <div className="mt-5">
            <h1 id="tableLabel" className="mb-3">檢測主機申請</h1>
            {(userType === 'S' || userType === 'M') && (
                <button
                    className={`mb-3 button-switch ${checked ? "on" : "off"}`}
                    onClick={handleChange}>
                    {checked ? "代理模式" : "掃描模式"}
                </button>
            )}
            <div id="site_manage" className="row col-12  justify-content-center" style={{ marginTop: '-15px' }}>
                <div className="row justify-content-center">
                    <div className="row col-sm-12 col-md-10 col-lg-8 rounded-3 d-inline-flex justify-content-start skin-white">
                        <h6 className="col-auto pt-2">個人同時最多可申請主機數: <span className="badge gray-green">{personalMaxApply}</span></h6>
                        <h6 className="col-auto pt-2">個人目前同時已經申請主機數: <span className="badge gray-green">{personalCurrentApply}</span></h6>
                        <h6 className="col-auto pt-2">個人目前同時可申請主機數: <span className="badge gray-green">{personalAvailableApply}</span></h6>
                        {/* <h6 className="col-auto pt-2">個人目前申請等待最快執行順位: <span className="badge gray-green">{this.state.waitingQueuePosition}</span></h6> */}
                        {(userType === 'S') && (
                            <h6 className="col-auto pt-2">目前系統已申請主機數: <span className="badge gray-green">{systemCurrentApply}</span></h6>)}
                    </div>
                </div>
                <div className="row col-sm-12 col-md-10 col-lg-8 rounded-3 d-inline-flex justify-content-center align-content-center mt-4">
                    {FormDataUI}
                </div>
            </div>
            <DataTable
                columns={columns}
                data={tableData}
                pagination
                highlightOnHover
                noDataComponent="There are no records to display"
                persistTableHead
            />
            <div style={{
                backgroundColor: 'lightblue',
                padding: '10px',
                borderRadius: '5px',
                marginTop: '20px'
            }}>
                <h4>注意說明</h4>
                <h5>申請前</h5>
                <ol>
                    <li>請確保在防火牆上將 140.113.27.150、140.113.27.151、140.113.27.152 和 140.113.27.153 設定白名單。</li>
                    <li>請確保被掃描主機 IP 是正確的，並且 140.113.27.150、140.113.27.151、140.113.27.152 和 140.113.27.153 能連到被掃描主機。</li>
                    <li>因為主機弱點掃描可能會導致主機網路連線異常，建議掃描時間內不要操作主機。</li>
                    <li>在執行主機弱點掃描前，請對主機進行備份，避免掃描後出現異常行為無法修復。</li>
                </ol>
                <h5>掃描完成後</h5>
                <ol>
                    <li>請確保主機使用一切正常。如果有異動或損毀，請使用備份或其他手動復原。</li>
                    <li>請確保移除 140.113.27.150、140.113.27.151、140.113.27.152 和 140.113.27.153 在防火牆的白名單。</li>
                </ol>
            </div>
        </div>
    );
}

export default CreateTenableApply;
